var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"equipment fade-in"},[_c('div',{staticClass:"equipment-content"},[_c('b-form-row',[_c('b-col',{staticClass:"col-12"},[_c('div',{staticClass:"equipment-subpanel"},_vm._l((_vm.equipment),function(value,key){return _c('EquipmentBlock',{key:key,attrs:{"equipmentSlot":value}})}),1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }